import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.PieChartView extends Monitoring.Views.Charts.ChartView
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  templateWithBenchmark: JST['backbone/templates/monitoring/charts/generic_with_benchmark_chart']
  className: 'processing item pie-chart'

  events:
    'click #benchmark-action #benchmark-day': 'onBenchmarkByDay'
    'click #benchmark-action #benchmark-week': 'onBenchmarkByWeek'
    'click #benchmark-action #remove-benchmark': 'onRemoveBenchmark'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @_settings.maximized = !!@_settings.maximized
    @container = @options.container
    @url = '/monitoring/api/charts/single_dimension'
    @benchmarkaActionTemplate = @initializeBenchmarkActionTemplate()

  initializeBenchmarkActionTemplate: () ->
    if @_settings.type == 'pie' && @options.showBenchmarkOption
      JST['backbone/templates/monitoring/charts/benchmark_action']
    else
      $.noop

  _dataIsEmpty: ->
    return !_.any(@getPieData(@name), (termAndCount) -> termAndCount[1] > 0 or termAndCount["y"] > 0)

  render: ->
    @$el.html(@template({ title: @title }))
    @trigger('masonry')
    @$el.find('#benchmark-action').html(@benchmarkaActionTemplate({hasOneBenchmark: false }) )
    @

  afterAppend: ->
    @$el.find('.chart').html('')
    if @_settings.maximized
      @$el.addClass('w2 h2')
    else
      if @dataBenchmark
        @$el.addClass('w2')
    setTimeout => # to avoid the harmless "Uncaught TypeError: a.onContainerClick is not a function"
      @benchmarkChart = new Highcharts.Chart(@benchmarkChartOptions(@current)) if @dataBenchmark
      @chart = new Highcharts.Chart($.extend(true, @_getOptions(), @_getChartOptions()))
      @trigger('masonry')
    , 20
    @$el.removeClass('processing')
    @trigger('masonry')

  _previewSearch: (event) =>
    query = @getNewQuery(event)
    query = new Monitoring.Views.Charts.QueryDateShifter(query).shiftXDaysBack(@shiftedDays) if @shiftedDays
    @createPreviewDashboard(query)

  _getOptions: ->
    pieData = @getPieData(@name)
    if pieData[0]? && pieData[0][0]?
      pieData = _.sortBy( pieData, (facet) -> (facet[0] || '').toLowerCase() )
      pieData = _.map(pieData, (facet) => {name: facet[0], y: facet[1], visible: @getVisibilityFor(facet[0])})
    else
      pieData = _.sortBy( pieData, (facet) -> (facet["name"] || '').toLowerCase() )

    pieOptions =  new Customer.Reports.PieOptions(
      container: @$el.find('.chart')[0]
      data: pieData
      onClick: @_previewSearch unless @_settings.avoid_preview
      legendItemClick: @legendItemClickEvent
      onToggleMaximize: => @toggleMaximize()
      isMaximized: @_settings.maximized
    ).get()

    _.each(pieOptions.series[0].data, (data) => data.color = @customColors()[data.name])

    return pieOptions

  toggleMaximize: ->
    @_settings.maximized = !@_settings.maximized
    if @_settings.maximized
      if @dataBenchmark
        @$el.addClass('w2 h2')
      else
        @$el.addClass('w2 h2')
    else
      @$el.removeClass('w2 h2')
      if @dataBenchmark
        @$el.addClass('w2')
      else
    @trigger('chartsChange')
    @afterAppend()

  getPieData: (name) ->
    return _.collect(@facets[name]['terms'], (value) ->
      [value.term, value.count]
    )

  customChartOptions: ->
    return undefined

  _getChartOptions: ->
    chartOptions = {}
    if @_settings.maximized
      chartOptions =
        legend:
          enabled: true
      $.extend(true, chartOptions, @customChartOptions()) if @customChartOptions()
    else
      chartOptions = @customChartOptions() if @customChartOptions()
    return chartOptions

  onBenchmarkByDay: () ->
    @shiftedDays = 1
    @_doBencharmark("day")
    @afterAppend()


  onBenchmarkByWeek: () ->
    @shiftedDays = 7
    @_doBencharmark("week")
    @afterAppend()

  onRemoveBenchmark: () ->
    return unless @shiftedDays
    @shiftedDays = undefined
    @dataBenchmark = undefined
    @benchmarkChart = undefined
    @$el.toggleClass('w2')
    @render()
    @afterAppend()

  _doBencharmark: (benchmark) ->
    query = @_getSearchQuery()
    if !@$el.hasClass('w2')
      @$el.addClass('w2')
    @afterAppend()
    query.set('benchmark', {
      date_from_ISO: query.get('date_from_ISO')
      date_to_ISO: query.get('date_to_ISO')
    })

    @ajaxCall(@url, query.toJSON(), (response) =>
      @dataBenchmark = response
      @current = I18n.t('monitoring.dashboard.charts.titles.'+benchmark)
      benchmark = 'Benchmark'
      @$el.html(@templateWithBenchmark({
        title: @title,
        current: @current,
        benchmark: benchmark
      }))
      @$el.find('#benchmark-action').html(@benchmarkaActionTemplate( {hasOneBenchmark: true } ))
      @removeActiveBenchmarkAction()
      @chart = new Highcharts.Chart($.extend(true, @_getOptions(), @_getChartOptions()))
      @benchmarkChart = new Highcharts.Chart(@benchmarkChartOptions(@current))
    )

  benchmarkChartOptions: (currentBenchmark) ->
    series = @_getOptions().series

    benchmark_series = $.extend({}, series[0])
    benchmark_series.data = $.extend([], @_benchmarkDataFromResponse())

    for group, index in series[0].data
      indexOfGroup = _.findIndex(benchmark_series.data, {name: group.name})
      indexOfGroup = _.findIndex(benchmark_series.data, {code: group.code}) if indexOfGroup == -1
      indexOfGroup = _.findIndex(benchmark_series.data, {code: group.code.split(' > ').join('_')}) if indexOfGroup == -1
      if indexOfGroup > -1
        benchmark_series.data[indexOfGroup].color = group.color
        benchmark_series.data[indexOfGroup].name = group.name
      else
        benchmark_series.data.push({name: group.name, y: 0, color: group.color})
        indexOfGroup = benchmark_series.data.length - 1
      if indexOfGroup != index
        [benchmark_series.data[index], benchmark_series.data[indexOfGroup]] = [benchmark_series.data[indexOfGroup], benchmark_series.data[index]]
    options = $.extend(true, @_getOptions(), @_getChartOptions())
    options.series = [benchmark_series]
    options.title = {text: currentBenchmark, y: 30, align: 'left', x:10, floating: true}
    options.title.style = {fontSize: '13px', fontWeight: 'bold'}
    options.chart.renderTo = @$el.find('.benchmark-chart')[0]
    return options

  removeActiveBenchmarkAction: ()->
    if @shiftedDays == 1
      @$el.find('#benchmark-day').hide()
    if @shiftedDays == 7
      @$el.find('#benchmark-week').hide()

  _benchmarkDataFromResponse: () ->
    @dataBenchmark.benchmark_data[0].data

  _getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('dimension', @name)
    if @shiftedDays
      new Monitoring.Views.Charts.QueryDateShifter(query).shiftXDaysBack(@shiftedDays)
    else
      query
